import request from '@/utils/request'

// 初始化公共头部信息
export function headerInfo(data) {
  return request({
    url: '/api/org/',
    method: 'get',
    data
  })
}
// 获取图形验证码
export function getLoginCkey(data) {
  return request({
    url: 'api/captcha',
    method: 'get',
  })
}

// 检验是否需要验证码
export function getIsCode(admin_account) {
  return request({
    url: 'api/Login/getIsCode',
    method: 'get',
    params: {
      admin_account
    }
  })
}

// 初始化公共头部信息
export function navInfo(data) {
  return request({
    url: '/api/org/get_nav_list',
    method: 'get',
    params: data
  })
}

// 获取手机验证码
export const getLoginCode = (params) => request.get('/api/login/get_code', { params })

// 用户注册
export const userRegister = (data) => request.post(`/api/user/register`, data)

// 注册班级列表
export const getGrades = (params) => request.get('/api/user/get_grades', { params })



// WEBPACK FOOTER //
// ./src/api/header.js